/**
 * This barrel file provides the export for the lazy loaded LoginModule.
 */
export * from './login.component';
export  * from './login.route';
export  * from './login.module';
